// dependencies
import createHook from "zustand";
import create from "zustand/vanilla";

// Config
// Schemas
// Endpoints
// utils
import getNested from "../../../utils/GetNested";

export const store = create((set, get) => ({
	init: (data) => {
		get().setSftpIntegrationID(getNested(data, "_id", ""));
		get().setSftpIntegrationName(getNested(data, "name", ""));
		get().setIntegrationEmailList(getNested(data, "emails", []));
		get().setIsTestingMode(getNested(data, "is_testing", false));
		get().setDeactivateUsersOnMissing(getNested(data, "deactivate_user_on_missing", false));
		get().setBackupIDField(getNested(data, "secondary_user_id", null));
		get().setFieldMapOverrides(getNested(data, "field_mapping_list", []));
		get().resyncCustomFieldsAvailableForFieldMap();

		get().setInitialData({
			name: getNested(data, "name", ""),
			emails: getNested(data, "emails", []),
			is_testing: getNested(data, "is_testing", false),
			deactivate_user_on_missing: getNested(data, "deactivate_user_on_missing", false),
			secondary_user_id: getNested(data, "secondary_user_id", null),
			field_mapping_list: getNested(data, "field_mapping_list", []),
		});
		// get().setHasChanges(false);
	},

	initialData: {},
	setInitialData: (data) => set({ initialData: data }),

	companyCustomFields: [],
	setCompanyCustomFields: (data) => {
		const sorted = data.sort((a, b) => {
			const nameA = a.name.toLowerCase();
			const nameB = b.name.toLowerCase();
			if (nameA < nameB) {
				return -1;
			}
			if (nameA > nameB) {
				return 1;
			}
			return 0;
		});
		set(() => ({ companyCustomFields: sorted }));
		get().resyncCustomFieldsAvailableForFieldMap();
	},

	customFieldsAvailableForFieldMap: [],
	resyncCustomFieldsAvailableForFieldMap: () => {
		const { companyCustomFields, fieldMapOverrides } = get();
		const fieldsUsedInFieldMap = fieldMapOverrides.map((fieldMap) => fieldMap.performyard_custom_field_name);
		const fieldsNotMappable = ["Login Status"];

		const customFieldsAvailableForFieldMap = companyCustomFields.filter(
			(field) => !fieldsUsedInFieldMap.includes(field.name) && !fieldsNotMappable.includes(field.name)
		);

		set({ customFieldsAvailableForFieldMap });
	},

	sftpIntegrationID: null,
	setSftpIntegrationID: (id) => set({ sftpIntegrationID: id }),

	// hasChanges   : false,
	// setHasChanges: hasChanges => set({ hasChanges }),

	sftpIntegrationName: "",
	setSftpIntegrationName: (name) => set({ sftpIntegrationName: name }),

	isTestingMode: false,
	setIsTestingMode: (isTestingMode) => set({ isTestingMode }),

	deactivateUsersOnMissing: false,
	setDeactivateUsersOnMissing: (deactivateUsersOnMissing) => set({ deactivateUsersOnMissing }),

	integrationEmailList: [],
	setIntegrationEmailList: (integrationEmailList) => set({ integrationEmailList }),
	addIntegrationEmail: (email) =>
		set((state) => ({
			integrationEmailList: [...state.integrationEmailList, email],
		})),
	removeIntegrationEmail: (index) =>
		set((state) => ({
			integrationEmailList: state.integrationEmailList.filter((_, i) => i !== index),
		})),
	updateIntegartionEmail: (index, newValue) => {
		const { integrationEmailList } = get();
		integrationEmailList[index] = newValue;
		set({ integrationEmailList });
	},

	backupIDField: null,
	setBackupIDField: (backupIDField) => set({ backupIDField }),

	fieldMapOverrides: [],
	setFieldMapOverrides: (fieldMapOverrides) => set({ fieldMapOverrides }),
	addFieldMapOverride: (mapperData) => {
		const { csv_column_name: csvFieldName, performyard_custom_field_name: performyardCustomFieldName } = mapperData;
		const { fieldMapOverrides, resyncCustomFieldsAvailableForFieldMap } = get();
		const newFieldMapOverrides = [
			...fieldMapOverrides,
			{
				csv_column_name: csvFieldName,
				performyard_custom_field_name: performyardCustomFieldName,
			},
		];
		set({ fieldMapOverrides: newFieldMapOverrides });
		resyncCustomFieldsAvailableForFieldMap();
	},
	removeFieldMapOverride: (index) => {
		const { fieldMapOverrides, resyncCustomFieldsAvailableForFieldMap } = get();
		const newFieldMapOverrides = fieldMapOverrides.filter((_, i) => i !== index);
		set({ fieldMapOverrides: newFieldMapOverrides });
		resyncCustomFieldsAvailableForFieldMap();
	},
	updateFieldMapOverride: (index, mapperData) => {
		const { csv_column_name: csvFieldName, performyard_custom_field_name: performyardCustomFieldName } = mapperData;
		const { fieldMapOverrides, resyncCustomFieldsAvailableForFieldMap } = get();
		const newFieldMapOverrides = fieldMapOverrides.map((existingValue, i) =>
			i === index
				? {
						csv_column_name: csvFieldName,
						performyard_custom_field_name: performyardCustomFieldName,
					}
				: existingValue
		);
		set({ fieldMapOverrides: newFieldMapOverrides });
		resyncCustomFieldsAvailableForFieldMap();
	},

	checkForChanges: () => {
		if (get().initialData) {
			const {
				name: savedName,
				is_testing: savedIsTestingMode,
				deactivate_user_on_missing: savedDeactivateUsersOnMissing,
				emails: savedIntegrationEmailList,
				secondary_user_id: savedBackupIDField,
				field_mapping_list: savedFieldMapOverrides,
			} = get().initialData;

			return (
				savedName !== get().sftpIntegrationName ||
				savedIsTestingMode !== get().isTestingMode ||
				savedDeactivateUsersOnMissing !== get().deactivateUsersOnMissing ||
				savedIntegrationEmailList !== get().integrationEmailList ||
				savedBackupIDField !== get().backupIDField ||
				savedFieldMapOverrides !== get().fieldMapOverrides
			);
		}

		return false;
	},
}));

// export default createHook(store);
const useStore = createHook(store);
export default useStore;
